// Translation: Utility > Feedback (Ukrainian)
export default Object.freeze({
	hint: ''
})
